import script from "./HouseholdCharacteristicsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HouseholdCharacteristicsSection.vue?vue&type=script&setup=true&lang=js"

import "./HouseholdCharacteristicsSection.vue?vue&type=style&index=0&id=d9fc2dbc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9fc2dbc"]])

export default __exports__